module.exports = __webpack_public_path__ + "img/02.62570700.png";